import { B as Button, c as chevronTemplateFactory, b as buttonDefinition } from './definition11.js';
import { P as Popup, p as popupDefinition } from './definition67.js';
import { I as Icon, i as iconDefinition } from './definition28.js';
import { P as ProgressRing, p as progressRingDefinition } from './definition39.js';
import { O as Observable, D as DOM, V as VividElement, a as attr, n as nullableNumberConverter, o as observable, h as html, d as createRegisterFunction, f as defineVividComponent } from './vivid-element.js';
import { a as WithFeedback, f as feedbackMessageDefinition } from './mixins.js';
import { s as scrollIntoView } from './scrollIntoView.js';
import { D as DelegatesAria, d as delegateAria } from './delegates-aria.js';
import { F as FormAssociated } from './form-associated.js';
import { W as WithErrorText } from './with-error-text.js';
import { W as WithSuccessText } from './with-success-text.js';
import { F as FormElement } from './form-element.js';
import { A as AffixIconWithTrailing, a as affixIconTemplateFactory, I as IconWrapper } from './affix.js';
import { L as Localized } from './localized.js';
import { i as isListboxOption } from './option.js';
import { w as when } from './when.js';
import { r as ref } from './ref.js';
import { s as slotted } from './slotted.js';
import { c as classNames } from './class-names.js';
import { r as repeat } from './repeat.js';

const styles = ".chevron{display:flex;flex-shrink:0;font:var(--vvd-typography-base-extended);transform:rotate(0);transition:transform .2s}:host([data-expanded=true]) .chevron,:host([open]) .chevron{transform:rotate(180deg)}:not(.disabled) .chevron{cursor:pointer}.disabled .chevron{color:var(--_low-ink-color);cursor:not-allowed}:host(:focus-visible){outline:none}:host{display:inline-block;inline-size:300px;--_low-ink-color: var(--vvd-color-neutral-600)}:host([disabled]){--_low-ink-color: var(--vvd-color-neutral-400);cursor:not-allowed}.control-wrapper{display:flex;flex-direction:column;gap:4px}.label{color:var(--vvd-color-canvas-text);font:var(--vvd-typography-base)}.selection-count{color:var(--_low-ink-color);font:var(--vvd-typography-base)}.fieldset{--_connotation-color-primary: var(--vvd-searchable-select-accent-primary, var(--vvd-color-canvas-text));--_connotation-color-primary-text: var(--vvd-searchable-select-accent-primary-text, var(--vvd-color-canvas));--_connotation-color-primary-increment: var(--vvd-searchable-select-accent-primary-increment, var(--vvd-color-neutral-800));--_connotation-color-intermediate: var(--vvd-searchable-select-accent-intermediate, var(--vvd-color-neutral-500));--_connotation-color-faint: var(--vvd-searchable-select-accent-faint, var(--vvd-color-neutral-50));--_connotation-color-soft: var(--vvd-searchable-select-accent-soft, var(--vvd-color-neutral-100));--_connotation-color-firm: var(--vvd-searchable-select-accent-firm, var(--vvd-color-canvas-text));--_connotation-color-fierce: var(--vvd-searchable-select-accent-fierce, var(--vvd-color-neutral-700))}.fieldset{--_appearance-color-text: var(--vvd-color-canvas-text);--_appearance-color-fill: var(--vvd-color-canvas);--_appearance-color-outline: var(--vvd-color-neutral-500)}.fieldset.appearance-ghost{--_appearance-color-text: var(--_connotation-color-firm);--_appearance-color-fill: transparent;--_appearance-color-outline: transparent}.fieldset:where(.hover,:hover):where(:not(.disabled,:disabled,.readonly)){--_appearance-color-text: var(--vvd-color-canvas-text);--_appearance-color-fill: var(--vvd-color-canvas);--_appearance-color-outline: var(--vvd-color-neutral-700)}.fieldset:where(.hover,:hover):where(:not(.disabled,:disabled,.readonly)).appearance-ghost{--_appearance-color-text: var(--_connotation-color-firm);--_appearance-color-fill: var(--_connotation-color-faint);--_appearance-color-outline: transparent}.fieldset:where(.disabled,:disabled){--_appearance-color-text: var(--vvd-color-neutral-300);--_appearance-color-fill: var(--vvd-color-neutral-100);--_appearance-color-outline: var(--vvd-color-neutral-300)}.fieldset:where(.disabled,:disabled).appearance-ghost{--_appearance-color-text: var(--vvd-color-neutral-300);--_appearance-color-fill: transparent;--_appearance-color-outline: transparent}.fieldset:where(.readonly):where(:not(.disabled,:disabled)){--_appearance-color-text: var(--vvd-color-canvas-text);--_appearance-color-fill: var(--vvd-color-neutral-200);--_appearance-color-outline: var(--vvd-color-neutral-400)}.fieldset:where(.readonly):where(:not(.disabled,:disabled)).appearance-ghost{--_appearance-color-text: var(--vvd-color-neutral-600);--_appearance-color-fill: transparent;--_appearance-color-outline: transparent}.fieldset:where(.error):where(:not(.disabled,:disabled)){--_appearance-color-text: notSet;--_appearance-color-fill: var(--vvd-color-alert-50);--_appearance-color-outline: var(--vvd-color-alert-500)}.fieldset:where(.error):where(:not(.disabled,:disabled)).appearance-ghost{--_appearance-color-text: notSet;--_appearance-color-fill: var(--vvd-color-alert-50);--_appearance-color-outline: transparent}.fieldset:where(.success):where(:not(.disabled,:disabled)){--_appearance-color-text: notSet;--_appearance-color-fill: var(--vvd-color-success-50);--_appearance-color-outline: var(--vvd-color-success-500)}.fieldset:where(.success):where(:not(.disabled,:disabled)).appearance-ghost{--_appearance-color-text: notSet;--_appearance-color-fill: var(--vvd-color-success-50);--_appearance-color-outline: transparent}.fieldset{display:flex;align-items:center;justify-content:space-between;background-color:var(--_appearance-color-fill);box-shadow:inset 0 0 0 1px var(--_appearance-color-outline);color:var(--_appearance-color-text);font:var(--vvd-typography-base);gap:8px;padding-block:8px;padding-inline:16px;transition:box-shadow .2s,background-color .2s}@supports selector(:has(*)){.fieldset:not(.has-highlighted-option):has(input:focus){box-shadow:0 0 0 4px color-mix(in srgb,var(--vvd-color-cta-500),transparent 85%),inset 0 0 0 3px var(--focus-stroke-gap-color, currentColor);outline:1px solid var(--focus-stroke-color, var(--vvd-color-cta-500));outline-offset:calc(-1px - var(--focus-inset, 0px));--focus-stroke-gap-color: transparent}}@supports not selector(:has(*)){.fieldset:not(.has-highlighted-option):focus-within{box-shadow:0 0 0 4px color-mix(in srgb,var(--vvd-color-cta-500),transparent 85%),inset 0 0 0 3px var(--focus-stroke-gap-color, currentColor);outline:1px solid var(--focus-stroke-color, var(--vvd-color-cta-500));outline-offset:calc(-1px - var(--focus-inset, 0px));--focus-stroke-gap-color: transparent}}:host(:not([shape=pill])) .fieldset{border-radius:8px}:host([shape=pill]) .fieldset{border-radius:24px}.popup-wrapper{position:relative}.content-area{display:flex;overflow:hidden;flex:1;flex-direction:column;gap:8px;min-block-size:24px}.tag-row{display:flex;gap:8px;inline-size:100%}.tag-row.contains-only-input:not(:focus-within){display:contents}.tag-wrapper{overflow:hidden}.tag{max-inline-size:100%}input{box-sizing:border-box;flex:1;border:none;background:none;block-size:24px;font:var(--vvd-typography-base);max-inline-size:100%;min-inline-size:min(100px,40%);outline:none}.contains-only-input input:not(:focus){position:absolute;block-size:0;inline-size:0;min-inline-size:0;opacity:0;pointer-events:none}.listbox{display:flex;flex-direction:column;padding:4px;gap:2px;max-block-size:var(--searchable-select-height, 408px);overflow-y:auto}.empty-message{display:flex;align-items:center;justify-content:center;color:var(--vvd-color-neutral-300);font:var(--vvd-typography-base);min-block-size:40px;text-align:center}::part(popup-base){inline-size:max-content;min-inline-size:var(--_searchable-select-fixed-width, 100%)}slot[name=icon]{font-size:20px}.visually-hidden{position:absolute;overflow:hidden;width:1px;height:1px;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap}::slotted([data-vvd-component=option][data-highlighted]){border-radius:8px;box-shadow:0 0 0 4px color-mix(in srgb,var(--vvd-color-cta-500),transparent 85%),inset 0 0 0 3px var(--focus-stroke-gap-color, currentColor);outline:1px solid var(--focus-stroke-color, var(--vvd-color-cta-500));outline-offset:calc(-1px - var(--focus-inset, 0px));--focus-stroke-gap-color: transparent}";

const optionTagStyles = ".base.connotation-cta{--_connotation-color-contrast: var(--vvd-option-tag-cta-contrast, var(--vvd-color-cta-800))}.base:not(.connotation-cta){--_connotation-color-contrast: var(--vvd-option-tag-accent-contrast, var(--vvd-color-neutral-800))}.base{position:relative;display:inline-flex;box-sizing:border-box;align-items:center;background-color:var(--fill-color);block-size:calc(1px*(24 + 4*clamp(-1,var(--vvd-size-density, 0),2)));box-shadow:inset 0 0 0 1px var(--outline-color);color:var(--text-color);column-gap:8px;font:var(--vvd-typography-base-bold);max-inline-size:100%;padding-inline:8px;user-select:none;vertical-align:middle}.base:not(.disabled){--text-color: var(--_connotation-color-contrast);--fill-color: var(--_connotation-color-soft);--outline-color: transparent}@supports (background-color: color-mix(in srgb,black 50%,white)){.base:not(.disabled){--fill-color: color-mix( in srgb, var(--_connotation-color-contrast), transparent 87.5% )}}.base.disabled{--text-color: var(--vvd-color-neutral-300);--fill-color: var(--vvd-color-neutral-200);--outline-color: transparent}@supports (background-color: color-mix(in srgb,black 50%,white)){.base.disabled{--fill-color: color-mix( in srgb, var(--vvd-color-neutral-800), transparent 87.5% )}}.base:not(.shape-pill){border-radius:4px}.base.shape-pill{border-radius:16px}.label{overflow:hidden;max-inline-size:100%;text-overflow:ellipsis;white-space:nowrap}slot[name=icon]{font-size:calc(calc(1px*(24 + 4*clamp(-1,var(--vvd-size-density, 0),2))) / 1.5);line-height:1}.icon-placeholder{inline-size:calc(calc(1px*(24 + 4*clamp(-1,var(--vvd-size-density, 0),2))) / 1.5)}.remove-button{display:flex;align-items:center;border-radius:inherit;cursor:pointer;outline:none}.disabled .remove-button{pointer-events:none}.remove-button:focus-visible:before{--focus-stroke-gap-color: transparent;box-shadow:0 0 0 4px color-mix(in srgb,var(--vvd-color-cta-500),transparent 85%),inset 0 0 0 3px var(--focus-stroke-gap-color, currentColor);outline:1px solid var(--focus-stroke-color, var(--vvd-color-cta-500));outline-offset:calc(-1px - var(--focus-inset, 0px));position:absolute;z-index:1;display:block;border-radius:inherit;content:\"\";inset:0;pointer-events:none}";

var __defProp$1 = Object.defineProperty;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp$1(target, key, result);
  return result;
};
const TagGapPx = 8;
const InputMinWidthPx = 100;
const PageSize = 10;
const isFormAssociatedTryingToSetFormValue = (value) => typeof value === "string";
class SearchableSelect extends WithFeedback(
  WithErrorText(
    WithSuccessText(
      FormElement(
        DelegatesAria(
          AffixIconWithTrailing(Localized(FormAssociated(VividElement)))
        )
      )
    )
  )
) {
  constructor() {
    super(...arguments);
    this.fixedDropdown = false;
    this.open = false;
    this.multiple = false;
    this.externalTags = false;
    this.maxLines = null;
    this.values = [];
    this.initialValues = [];
    this._currentSearchText = null;
    // --- Slotted options ---
    /**
     * @internal
     */
    this._areOptionsInitialized = false;
    this.#slottedOptionsChangeHandler = {
      handleChange: (source, _) => {
        if (source.selected && !this.values.includes(source.value)) {
          this.values = [...this.values, source.value];
        } else if (!source.selected && this.values.includes(source.value)) {
          this.values = this.values.filter((option) => option !== source.value);
        }
      }
    };
    // --- Option tag icons ---
    this.#clonedTagIcons = /* @__PURE__ */ new Map();
    this._filteredOptions = [];
    this._filteredEnabledOptions = [];
    this.loading = false;
    this._highlightedOptionIndex = null;
    this._numElidedTags = 0;
    this._tagRows = [];
    this._lastTagRow = [];
    this.clearable = false;
    this.maxSelected = null;
    this._slottedDisabledOptions = [];
    // --- Form handling ---
    /**
     * @internal
     */
    this.proxy = document.createElement("input");
    this.setFormValue = (value, state) => {
      if (isFormAssociatedTryingToSetFormValue(value)) {
        return;
      }
      super.setFormValue(value, state);
    };
    this._changeDescription = "";
    // --- Core ---
    this.#resizeObserver = new ResizeObserver(() => {
      this.#updateTagLayout();
    });
  }
  /**
   * @internal
   */
  openChanged() {
    if (!this.open) {
      this.#transitionHighlightedOptionTo(null);
    }
  }
  /**
   * @internal
   */
  valuesChanged() {
    if (!this._areOptionsInitialized) {
      return;
    }
    if (!this.multiple && this.values.length > 1) {
      this.values = [this.values[0]];
      return;
    }
    if (this.values.some((value) => !this.#isValidValue(value))) {
      this.values = this.values.filter((value) => this.#isValidValue(value));
      return;
    }
    this.value = this.values.length ? this.values[0] : "";
    this.#updateSelectionLimit();
    this.#updateSelectedOnSlottedOptions();
    if (this.$fastController.isConnected) {
      this.#updateTagLayout();
    }
    this.#updateFormValue();
  }
  #updateValuesThroughUserInteraction(newValues) {
    this.values = newValues;
    this.$emit("change", void 0, {
      bubbles: false
    });
    this.$emit("input", void 0, {
      bubbles: false
    });
  }
  #updateValuesWhileMaintainingOrder(newValues) {
    const oldSet = new Set(this.values);
    const newSet = new Set(newValues);
    this.values = [...this.values].filter((v) => newSet.has(v)).concat([...newValues].filter((v) => !oldSet.has(v)));
  }
  /**
   * @internal
   */
  initialValuesChanged() {
    if (!this.dirtyValue) {
      this.values = this.initialValues;
      this.dirtyValue = false;
    }
  }
  #isValidValue(value) {
    return this._slottedOptions.some((option) => option.value === value);
  }
  /**
   * @internal
   */
  valueChanged(prev, next) {
    super.valueChanged(prev, next);
    if (!this._areOptionsInitialized) {
      return;
    }
    const isValidValue = this._slottedOptions.some(
      (option) => option.value === next
    );
    if (this.values[0] !== next) {
      this.values = isValidValue ? [next] : [];
    }
  }
  get selectedIndex() {
    if (this.values.length) {
      return this._slottedOptions.findIndex(
        (option) => option.value === this.values[0]
      );
    } else {
      return -1;
    }
  }
  set selectedIndex(index) {
    this.value = this._slottedOptions[index]?.value ?? "";
  }
  get options() {
    return [...this._slottedOptions];
  }
  get selectedOptions() {
    return this._slottedOptions.filter(
      (option) => this.values.includes(option.value)
    );
  }
  /**
   * @internal
   */
  _currentSearchTextChanged() {
    this.#updateFilteredOptions();
    this.$emit("search-text-change", void 0, {
      bubbles: false,
      composed: false
    });
  }
  /**
   * The current search text of the component.
   */
  get searchText() {
    return this._currentSearchText ?? "";
  }
  /**
   * @internal
   */
  get _inputValue() {
    return this._currentSearchText ?? (!this.multiple && this.value !== "" ? this.#textForValue(this.value) ?? "" : "");
  }
  /**
   * @internal
   */
  _onInputInput(event) {
    this._currentSearchText = event.target.value;
  }
  /**
   * @internal
   */
  _onInputFocus(_) {
    this.#updateFilteredOptions();
  }
  /**
   * @internal
   */
  _onInputBlur(_) {
    this.open = false;
    this._currentSearchText = null;
    this._changeDescription = "";
  }
  /**
   * @internal
   */
  _onInputKeydown(e) {
    if (e.ctrlKey || e.shiftKey) {
      return true;
    }
    switch (e.key) {
      case "Enter":
        this.#selectHighlightedOption();
        if (this._inputValue === "") {
          this.open = !this.open;
        }
        return false;
      case "Escape":
        this.open = false;
        break;
      case "Home":
        if (!this.open) {
          this.open = true;
          break;
        }
        this.#highlightFirstOption();
        return false;
      case "End":
        if (!this.open) {
          this.open = true;
          break;
        }
        this.#highlightLastOption();
        return false;
      case "PageUp":
        if (!this.open) {
          this.open = true;
          break;
        }
        this.#highlightPrevPage();
        return false;
      case "PageDown":
        if (!this.open) {
          this.open = true;
          break;
        }
        this.#highlightNextPage();
        return false;
      case "ArrowUp":
        if (!this.open) {
          this.open = true;
          break;
        }
        this.#highlightPreviousOption();
        return false;
      case "ArrowDown":
        if (!this.open) {
          this.open = true;
          break;
        }
        this.#highlightNextOption();
        return false;
      case "ArrowLeft":
        if (this.multiple && this._inputValue === "" && this.values.length && !this.externalTags) {
          this.#moveTagFocusTo(this.#nextTagIndexLeft(this.values.length));
          return false;
        }
        return true;
      case "Backspace":
        if (this.multiple && this._inputValue === "" && this.values.length) {
          this._onTagRemoved(this.values[this.values.length - 1]);
          return false;
        }
        return true;
      default:
        if (!this.open) {
          this.open = true;
        }
        return true;
    }
    return true;
  }
  /**
   * @internal
   */
  _slottedOptionsChanged(oldValue, newValue) {
    const hasSlottedOptions = Boolean(
      this.querySelectorAll(`:not([slot])`).length
    );
    if (!newValue.length && hasSlottedOptions) {
      return;
    }
    this._areOptionsInitialized = true;
    if (oldValue) {
      this._slottedDisabledOptions = [];
      for (const option of oldValue) {
        const notifier = Observable.getNotifier(option);
        notifier.unsubscribe(this.#slottedOptionsChangeHandler, "selected");
      }
    }
    if (newValue) {
      for (const option of newValue) {
        option._displayCheckmark = true;
        const notifier = Observable.getNotifier(option);
        notifier.subscribe(this.#slottedOptionsChangeHandler, "selected");
      }
    }
    const values = [];
    for (const option of this._slottedOptions) {
      if (option.selected || option.value === this.value || this.values.includes(option.value)) {
        values.push(option.value);
      }
      if (option.disabled) {
        this._slottedDisabledOptions.push(option);
      }
    }
    this.#updateValuesWhileMaintainingOrder(values);
    this.#updateFilteredOptions();
    this.#updateSelectionLimit();
  }
  #slottedOptionsChangeHandler;
  #updateSelectedOnSlottedOptions() {
    for (const option of this._slottedOptions) {
      option.selected = this.values.includes(option.value);
      this.#updateClonedTagIconOfOption(option);
    }
  }
  #handleOptionInteraction(option) {
    const value = option.value;
    let newValues;
    let shouldClearSearchText = false;
    const isSelection = !this.values.includes(value);
    if (this.multiple) {
      if (isSelection) {
        newValues = [...this.values, value];
      } else {
        newValues = this.values.filter((option2) => option2 !== value);
      }
      shouldClearSearchText = true;
    } else {
      if (isSelection) {
        newValues = [value];
        shouldClearSearchText = true;
      } else {
        newValues = [];
      }
      this.open = false;
    }
    this.#updateValuesThroughUserInteraction(newValues);
    const optionMessage = isSelection ? this.locale.searchableSelect.optionSelectedMessage(option.text) : this.locale.searchableSelect.optionDeselectedMessage(option.text);
    const maxSelectedMessage = this.multiple && this.maxSelected && this.maxSelected >= 1 ? this.locale.searchableSelect.maxSelectedMessage(
      this.values.length,
      this.maxSelected
    ) : "";
    this._changeDescription = `${optionMessage} ${maxSelectedMessage}`;
    if (shouldClearSearchText) {
      this._currentSearchText = null;
    }
  }
  #clonedTagIcons;
  #tagIconOfOption(option) {
    return option.querySelector('[slot="tag-icon"]');
  }
  /**
   * @internal
   */
  _tagIconSlotName(value) {
    return `_tag-icon-${this.values.indexOf(value)}`;
  }
  #updateClonedTagIconOfOption(option) {
    if (option.selected && this.#tagIconOfOption(option)) {
      let clone = this.#clonedTagIcons.get(option);
      if (!clone) {
        clone = this.#tagIconOfOption(option).cloneNode(true);
        this.#clonedTagIcons.set(option, clone);
      }
      clone.slot = this._tagIconSlotName(option.value);
      this.appendChild(clone);
    } else {
      const clone = this.#clonedTagIcons.get(option);
      if (clone) {
        clone.remove();
        this.#clonedTagIcons.delete(option);
      }
    }
  }
  /**
   * @internal
   */
  optionFilterChanged() {
    this.#updateFilteredOptions();
  }
  /**
   * @internal
   */
  loadingChanged(_oldValue, newValue) {
    this._changeDescription = this.locale.searchableSelect.loadingOptionsMessage;
    if (_oldValue && !newValue) this._changeDescription = "";
  }
  #updateFilteredOptions() {
    const newFilteredOptions = [];
    const optionFilter = this.optionFilter ?? ((option, searchText) => option.text.toLowerCase().includes(searchText.toLowerCase()));
    for (const option of this._slottedOptions ?? []) {
      option._vvdSearchText = this.searchText;
      const matches = !this.searchText || optionFilter(option, this.searchText);
      option._isNotMatching = !matches;
      if (!option.hidden && matches) {
        newFilteredOptions.push(option);
      }
    }
    this.#transitionHighlightedOptionTo(null);
    this._filteredOptions = newFilteredOptions;
    this._filteredEnabledOptions = newFilteredOptions.filter(
      (option) => !option.disabled
    );
  }
  #transitionHighlightedOptionTo(index) {
    if (typeof this._highlightedOptionIndex === "number") {
      const prevOption = this._filteredEnabledOptions[this._highlightedOptionIndex];
      prevOption._highlighted = false;
      prevOption.removeAttribute("data-highlighted");
    }
    if (typeof index === "number") {
      if (!this._filteredEnabledOptions.length) {
        index = null;
      } else {
        index = Math.max(
          0,
          Math.min(this._filteredEnabledOptions.length - 1, index)
        );
      }
    }
    this._highlightedOptionIndex = index;
    if (typeof this._highlightedOptionIndex === "number") {
      const highlightedOption = this._filteredEnabledOptions[this._highlightedOptionIndex];
      highlightedOption._highlighted = true;
      highlightedOption.setAttribute("data-highlighted", "");
      scrollIntoView(highlightedOption, this._listbox, "nearest");
      this._changeDescription = this.locale.searchableSelect.optionFocusedMessage(
        highlightedOption.text,
        this._highlightedOptionIndex + 1,
        this._filteredEnabledOptions.length,
        highlightedOption.selected
      );
    }
  }
  #selectHighlightedOption() {
    if (this._highlightedOptionIndex === null) {
      return;
    }
    this.#handleOptionInteraction(
      this._filteredEnabledOptions[this._highlightedOptionIndex]
    );
  }
  #highlightFirstOption() {
    this.#transitionHighlightedOptionTo(0);
  }
  #highlightLastOption() {
    this.#transitionHighlightedOptionTo(
      this._filteredEnabledOptions.length - 1
    );
  }
  #highlightPrevPage() {
    this.#transitionHighlightedOptionTo(
      (this._highlightedOptionIndex ?? this._filteredEnabledOptions.length) - PageSize
    );
  }
  #highlightNextPage() {
    this.#transitionHighlightedOptionTo(
      (this._highlightedOptionIndex ?? -1) + PageSize
    );
  }
  #highlightPreviousOption() {
    this.#transitionHighlightedOptionTo(
      (this._highlightedOptionIndex ?? this._filteredEnabledOptions.length) - 1
    );
  }
  #highlightNextOption() {
    this.#transitionHighlightedOptionTo(
      (this._highlightedOptionIndex ?? -1) + 1
    );
  }
  // --- Tags ---
  /**
   * @internal
   */
  _tagLabelForValue(value) {
    const option = this._slottedOptions.find(
      (option2) => option2.value === value
    );
    return option.label;
  }
  /**
   * @internal
   */
  _tagConnotationForValue(value) {
    const option = this._slottedOptions.find(
      (option2) => option2.value === value
    );
    return option.tagConnotation;
  }
  /**
   * @internal
   */
  _isTagDisabled(value) {
    const option = this._slottedOptions.find(
      (option2) => option2.value === value
    );
    return this.disabled || option.disabled;
  }
  #textForValue(value) {
    const option = this._slottedOptions?.find(
      (option2) => option2.value === value
    );
    return option?.label;
  }
  /**
   * @internal
   */
  #measureTagWidth(label, removable, hasIcon) {
    const tag = document.createElement(this._optionTagTagName);
    tag.label = label;
    tag.removable = removable;
    tag.style.cssText = "position: absolute; visibility: hidden;";
    tag.hasIconPlaceholder = hasIcon;
    this.shadowRoot.appendChild(tag);
    const width = tag.getBoundingClientRect().width;
    tag.remove();
    return width;
  }
  #updateTagLayout() {
    if (!this.multiple) {
      this._numElidedTags = 0;
      this._tagRows = [];
      this._lastTagRow = [];
      return;
    }
    if (this.externalTags) {
      this._numElidedTags = this.values.length;
      this._tagRows = [];
      this._lastTagRow = [];
      return;
    }
    const rowWidth = this._contentArea.getBoundingClientRect().width;
    const rows = [[]];
    let currentRowIndex = 0;
    let currentRowWidth = InputMinWidthPx;
    let i;
    for (i = this.values.length - 1; i >= 0; i--) {
      const isLastRow = this.maxLines && currentRowIndex === this.maxLines - 1;
      const tagWidth = this.#measureTagWidth(
        this._tagLabelForValue(this.values[i]),
        true,
        this.#tagIconOfOption(this.selectedOptions[i]) !== null
      );
      const entry = {
        value: this.values[i],
        width: tagWidth
      };
      let elidedTagCounterWidth = 0;
      if (isLastRow) {
        const numElidedTags = i;
        if (numElidedTags) {
          elidedTagCounterWidth = TagGapPx + this.#measureTagWidth(numElidedTags.toString(), false, false);
        }
      }
      const totalWidthNeeded = currentRowWidth + TagGapPx + tagWidth + elidedTagCounterWidth;
      if (totalWidthNeeded > rowWidth) {
        if (isLastRow) {
          if (i === this.values.length - 1) {
            rows[currentRowIndex].unshift(entry);
            currentRowWidth += TagGapPx + tagWidth;
          } else {
            break;
          }
        } else {
          rows.push([]);
          currentRowIndex++;
          rows[currentRowIndex].unshift(entry);
          currentRowWidth = tagWidth;
        }
        continue;
      }
      rows[currentRowIndex].unshift(entry);
      currentRowWidth += TagGapPx + tagWidth;
    }
    this._numElidedTags = i + 1;
    rows.reverse();
    for (let i2 = 0; i2 < rows.length - 1; i2++) {
      let lineWidth = rows[i2].map((e) => e.width).reduce((a, b) => a + b, 0) + (rows[i2].length - 1) * TagGapPx;
      if (i2 === 0 && this._numElidedTags) {
        lineWidth += TagGapPx + this.#measureTagWidth(this._numElidedTags.toString(), false, false);
      }
      while (rows[i2 + 1].length && lineWidth + TagGapPx + rows[i2 + 1][0].width <= rowWidth) {
        const nextTag = rows[i2 + 1].shift();
        rows[i2].push(nextTag);
        lineWidth += TagGapPx + nextTag.width;
      }
    }
    const rowValues = rows.map((line) => line.map((entry) => entry.value));
    this._tagRows = rowValues.slice(0, -1);
    this._lastTagRow = rowValues.slice(-1)[0];
  }
  /**
   * @internal
   */
  _onTagRemoved(value) {
    this.#updateValuesThroughUserInteraction(
      this.values.filter((option) => option !== value)
    );
    this.#updateFilteredOptions();
  }
  /**
   * @internal
   */
  _onTagKeydown(event) {
    const tagIndex = parseInt(event.target.dataset.index);
    switch (event.key) {
      case "Backspace":
      case "Delete":
      case "Enter":
      case " ": {
        this._onTagRemoved(this.values[tagIndex]);
        DOM.processUpdates();
        this.#moveTagFocusTo(this.#nextTagIndexForRemoved(tagIndex));
        break;
      }
      case "ArrowLeft":
        this.#moveTagFocusTo(this.#nextTagIndexLeft(tagIndex) ?? tagIndex);
        break;
      case "ArrowRight":
        this.#moveTagFocusTo(this.#nextTagIndexRight(tagIndex));
        break;
    }
    return true;
  }
  #moveTagFocusTo(index) {
    if (index === null) {
      this._input.focus();
    } else {
      this.shadowRoot.querySelector(`[data-index="${index}"]`)?.focus();
    }
  }
  #nextTagIndexLeft(index) {
    if (!this.values.length) {
      return null;
    }
    for (let i = index - 1; i >= 0; i--) {
      if (!this._isTagDisabled(this.values[i])) {
        return i;
      }
    }
    return null;
  }
  #nextTagIndexRight(index) {
    if (!this.values.length) {
      return null;
    }
    for (let i = index + 1; i < this.values.length; i++) {
      if (!this._isTagDisabled(this.values[i])) {
        return i;
      }
    }
    return null;
  }
  #nextTagIndexForRemoved(index) {
    return this.#nextTagIndexRight(index - 1) ?? this.#nextTagIndexLeft(index);
  }
  /**
   * @internal
   */
  _onListboxClick(e) {
    if (this.disabled) {
      return;
    }
    const capturedOption = e.target.closest(
      `option,[role=option],[data-vvd-component=option]`
    );
    if (capturedOption && !capturedOption.disabled) {
      this.#handleOptionInteraction(capturedOption);
    }
  }
  /**
   * @internal
   */
  get _shouldShowClearButton() {
    return this.clearable && this.values.length > 0;
  }
  /**
   * @internal
   */
  _onClearButtonClick() {
    this.#updateValuesThroughUserInteraction(
      this.selectedOptions.filter((option) => option.disabled).map((option) => option.value)
    );
  }
  /**
   * @internal
   */
  maxSelectedChanged() {
    this.#updateSelectionLimit();
  }
  #updateSelectionLimit() {
    if (!this.multiple || !this._slottedOptions || typeof this.maxSelected !== "number" || this.maxSelected <= 0) {
      return;
    }
    const options = this._slottedOptions.filter(
      (option) => !this._slottedDisabledOptions.includes(option)
    );
    if (this.values.length >= this.maxSelected) {
      const unselectedOptions = options.filter(
        (option) => !this.selectedOptions.includes(option)
      );
      for (const option of unselectedOptions) {
        option.disabled = true;
      }
    } else {
      for (const option of options) {
        option.disabled = false;
      }
    }
  }
  #determineInitialValues() {
    return this.initialValues.length ? this.initialValues : this.initialValue ? [this.initialValue] : [];
  }
  /**
   * @internal
   */
  nameChanged(previous, next) {
    super.nameChanged(previous, next);
    this.#updateFormValue();
  }
  #updateFormValue() {
    if (!this.name) {
      this.setFormValue(null);
    } else {
      const formData = new FormData();
      for (const value of this.values) {
        formData.append(this.name, value);
      }
      this.setFormValue(formData);
    }
  }
  /**
   * @internal
   */
  formResetCallback() {
    super.formResetCallback();
    this.#updateValuesThroughUserInteraction(this.#determineInitialValues());
  }
  #resizeObserver;
  /**
   * @internal
   */
  _onFieldsetClick(e) {
    if (this.disabled) {
      return;
    }
    if (!e.defaultPrevented) {
      this._input.focus();
      this.open = true;
    }
  }
  /**
   * @internal
   */
  _onChevronClick() {
    if (this.open) {
      this.open = false;
      return false;
    }
    return true;
  }
  connectedCallback() {
    super.connectedCallback();
    if (!this.values.length) {
      this.values = this.#determineInitialValues();
    }
    this.#resizeObserver.observe(this._contentArea);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#resizeObserver.disconnect();
  }
  /**
   * @internal
   */
  validate() {
    super.validate(this._input ?? void 0);
  }
  /**
   * @internal
   */
  focus(options) {
    this._input?.focus(options);
  }
  /**
   * @internal
   */
  _onMouseDown(event) {
    const originalTarget = event.composedPath()[0];
    if (!event.defaultPrevented && originalTarget !== this._input) {
      this._input.focus();
      return false;
    }
    return true;
  }
}
__decorateClass$1([
  attr
], SearchableSelect.prototype, "appearance");
__decorateClass$1([
  attr
], SearchableSelect.prototype, "shape");
__decorateClass$1([
  attr({ mode: "boolean", attribute: "fixed-dropdown" })
], SearchableSelect.prototype, "fixedDropdown");
__decorateClass$1([
  attr
], SearchableSelect.prototype, "placeholder");
__decorateClass$1([
  attr({ mode: "boolean" })
], SearchableSelect.prototype, "open");
__decorateClass$1([
  attr({ mode: "boolean" })
], SearchableSelect.prototype, "multiple");
__decorateClass$1([
  attr({ attribute: "external-tags", mode: "boolean" })
], SearchableSelect.prototype, "externalTags");
__decorateClass$1([
  attr({ attribute: "max-lines", converter: nullableNumberConverter })
], SearchableSelect.prototype, "maxLines");
__decorateClass$1([
  observable
], SearchableSelect.prototype, "values");
__decorateClass$1([
  observable
], SearchableSelect.prototype, "initialValues");
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_input");
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_currentSearchText");
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_slottedOptions");
__decorateClass$1([
  observable
], SearchableSelect.prototype, "optionFilter");
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_filteredOptions");
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_filteredEnabledOptions");
__decorateClass$1([
  attr({
    mode: "boolean"
  })
], SearchableSelect.prototype, "loading");
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_highlightedOptionIndex");
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_contentArea");
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_numElidedTags");
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_tagRows");
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_lastTagRow");
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_listbox");
__decorateClass$1([
  attr({ mode: "boolean" })
], SearchableSelect.prototype, "clearable");
__decorateClass$1([
  attr({ attribute: "max-selected", converter: nullableNumberConverter })
], SearchableSelect.prototype, "maxSelected");
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_slottedDisabledOptions");
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_changeDescription");
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_anchor");

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class OptionTag extends Localized(VividElement) {
  constructor() {
    super(...arguments);
    this.removable = false;
    this.disabled = false;
    this.hasIconPlaceholder = false;
  }
  _onClickRemove() {
    this.$emit("remove", void 0, {
      bubbles: false
    });
  }
}
__decorateClass([
  attr
], OptionTag.prototype, "shape");
__decorateClass([
  observable
], OptionTag.prototype, "connotation");
__decorateClass([
  attr
], OptionTag.prototype, "label");
__decorateClass([
  attr({ mode: "boolean" })
], OptionTag.prototype, "removable");
__decorateClass([
  attr({ mode: "boolean" })
], OptionTag.prototype, "disabled");
__decorateClass([
  observable
], OptionTag.prototype, "hasIconPlaceholder");

const getStateClasses = (x) => classNames(
  ["disabled", x.disabled],
  [`appearance-${x.appearance}`, Boolean(x.appearance)],
  [`shape-${x.shape}`, Boolean(x.shape)],
  ["error", Boolean(x.errorValidationMessage)],
  ["success", !!x.successText],
  ["has-highlighted-option", x._highlightedOptionIndex !== null]
);
function renderLabel() {
  return html`
		<label for="control" class="label" id="label"> ${(x) => x.label} </label>
	`;
}
function renderSelectionCount() {
  return html`
		<span
			id="selection-count"
			class="selection-count"
			aria-label="${(x) => x.locale.searchableSelect.maxSelectedMessage(
    x.values.length,
    x.maxSelected
  )}"
			>(${(x) => `${x.values.length}/${x.maxSelected}`})</span
		>
	`;
}
const tagTemplateFactory = (context, getComponent) => {
  const optionTagTag = context.tagFor(OptionTag);
  return html`
		<div class="tag-wrapper">
			<${optionTagTag}
				class="tag"
				tabindex="-1"
				data-index="${(x, c) => getComponent(c).values.indexOf(x)}"
				removable
				:label="${(x, c) => getComponent(c)._tagLabelForValue(x)}"
				:shape="${(_, c) => getComponent(c).shape}"
				:connotation="${(x, c) => getComponent(c)._tagConnotationForValue(x)}"
				?disabled="${(x, c) => getComponent(c)._isTagDisabled(x)}"
				@remove="${(x, c) => getComponent(c)._onTagRemoved(x)}"
				@keydown="${(_, c) => getComponent(c)._onTagKeydown(c.event)}"
				@mousedown="${() => false}">
				<slot slot="icon" name="${(x, c) => getComponent(c)._tagIconSlotName(x)}"></slot>
			</${optionTagTag}>
		</div>
	`;
};
const elidedTagTemplateFactory = (context, getComponent) => {
  const optionTagTag = context.tagFor(OptionTag);
  return html`
		<${optionTagTag}
			class="tag"
			tabindex="-1"
			:label="${(x, c) => getComponent(x, c)._numElidedTags.toString()}"
			:shape="${(x, c) => getComponent(x, c).shape}"
			?disabled="${(x, c) => getComponent(x, c).disabled}"
			@mousedown="${() => false}">
		</${optionTagTag}>
	`;
};
function renderFieldset(context) {
  const buttonTag = context.tagFor(Button);
  const progressRingTag = context.tagFor(ProgressRing);
  const affixIconTemplate = affixIconTemplateFactory(context);
  const chevronTemplate = chevronTemplateFactory(context);
  const tagTemplate = tagTemplateFactory(context, (c) => c.parent);
  const nestedTagTemplate = tagTemplateFactory(
    context,
    (c) => c.parentContext.parent
  );
  const elidedTagTemplate = elidedTagTemplateFactory(context, (x, _) => x);
  const nestedElidedTagTemplate = elidedTagTemplateFactory(
    context,
    (_, c) => c.parent
  );
  return html`
		<div
			class="fieldset ${getStateClasses}"
			@click="${(x, c) => x._onFieldsetClick(c.event)}"
			${ref("_anchor")}
		>
			${(x) => affixIconTemplate(x.icon, IconWrapper.Slot)}
			<div class="content-area" ${ref("_contentArea")}>
				${repeat(
    (x) => x._tagRows,
    html`
						<div class="tag-row">
							${when(
      (_, c) => c.isFirst && c.parent._numElidedTags,
      nestedElidedTagTemplate
    )}
							${repeat((x) => x, nestedTagTemplate)}
						</div>
					`,
    { positioning: true }
  )}
				<div
					class="tag-row ${(x) => classNames([
    "contains-only-input",
    x._tagRows.length > 0 && x._lastTagRow.length === 0
  ])}"
				>
					${when(
    (x) => x._tagRows.length === 0 && x._numElidedTags,
    elidedTagTemplate
  )}
					${repeat((x) => x._lastTagRow, tagTemplate)}
					<input
						id="control"
						class="control"
						autocomplete="off"
						aria-controls="listbox"
						aria-describedby="${(x) => x._feedbackDescribedBy} ${(x) => x.multiple && x.maxSelected && x.maxSelected >= 1 ? "selection-count" : null}"
						${delegateAria({
    role: "combobox",
    ariaAutoComplete: "list",
    ariaHasPopup: "listbox",
    ariaExpanded: (x) => x.open
  })}
						placeholder="${(x) => x.multiple && x.values.length ? "" : x.placeholder}"
						type="text"
						?disabled="${(x) => x.disabled}"
						:value="${(x) => x._inputValue}"
						@input="${(x, c) => {
    x._onInputInput(c.event);
    c.event.stopPropagation();
  }}"
						@change="${(_, c) => {
    c.event.stopPropagation();
  }}"
						@focus="${(x, c) => x._onInputFocus(c.event)}"
						@blur="${(x, c) => x._onInputBlur(c.event)}"
						@keydown="${(x, c) => x._onInputKeydown(c.event)}"
						${ref("_input")}
					/>
				</div>
			</div>
			<slot name="meta"></slot>
			${when(
    (x) => x._shouldShowClearButton,
    html`<${buttonTag}
					aria-label="${(x) => x.locale.searchableSelect.clearButtonLabel}"
					@click="${(x) => x._onClearButtonClick()}"
					@mousedown="${() => false}"
					?disabled="${(x) => x.disabled}"
					:shape="${(x) => x.shape}"
					size="super-condensed"
					icon="close-line"
					appearance="ghost-light"
					tabindex="0"
				></${buttonTag}>`
  )}
			<div @mousedown="${() => false}" @click="${(x) => x._onChevronClick()}">
				${when(
    (x) => x.loading,
    html`<${progressRingTag} indeterminate size="-6" aria-hidden="true"></${progressRingTag}>`
  )}
				${when((x) => !x.loading, chevronTemplate)}
			</div>
		</div>
	`;
}
function setFixedDropdownVarWidth(x) {
  return x.open && x.fixedDropdown ? `--_searchable-select-fixed-width: ${Math.round(
    x.getBoundingClientRect().width
  )}px` : null;
}
function renderControl(context) {
  const popupTag = context.tagFor(Popup);
  return html`
		${when(
    (x) => x.label || x.multiple && x.maxSelected && x.maxSelected >= 1,
    html`
				<div>
					${when((x) => x.label, renderLabel())}
					${when(
      (x) => x.multiple && x.maxSelected && x.maxSelected >= 1,
      renderSelectionCount()
    )}
				</div>
			`
  )}
		<span aria-live="assertive" aria-relevant="text" class="visually-hidden">
			${(x) => x._changeDescription}
		</span>
		<div>
			${renderFieldset(context)}
			<div class="popup-wrapper">
				<${popupTag}
					:anchor="${(x) => x._anchor}"
					:open="${(x) => x.open}"
					class="popup"
					placement="bottom-start"
					style="${setFixedDropdownVarWidth}"
					strategy="${(x) => x.fixedDropdown ? "fixed" : "absolute"}">
					<div
						class="listbox"
						role="listbox"
						aria-multiselectable="${(x) => x.multiple}"
						aria-required="${(x) => x.required}"
						${ref("_listbox")}
						@click="${(x, c) => x._onListboxClick(c.event)}"
						@mousedown="${() => false}"
					>
						<slot
							${slotted({
    filter: isListboxOption,
    flatten: true,
    property: "_slottedOptions"
  })}>
						</slot>
						${when(
    (x) => x._filteredOptions.length === 0,
    html`<div class="empty-message">
								${when(
      (x) => x.loading,
      html`<slot name="loading-options">
										${(x) => x.locale.searchableSelect.loadingOptionsMessage}
									</slot>`
    )}
								${when(
      (x) => !x.loading && x.searchText === "",
      html`<slot name="no-options">
										${(x) => x.locale.searchableSelect.noOptionsMessage}
									</slot>`
    )}
								${when(
      (x) => !x.loading && x.searchText !== "",
      html`<slot name="no-matches">
										${(x) => x.locale.searchableSelect.noMatchesMessage}
									</slot>`
    )}
							</div>`
  )}
					</div>
				</${popupTag}>
			</div>
		</div>
	`;
}
const SearchableSelectTemplate = (context) => {
  const optionTagTag = context.tagFor(OptionTag);
  return html`
		<template
			:_optionTagTagName="${() => optionTagTag}"
			@mousedown="${(x, c) => x._onMouseDown(c.event)}"
		>
			<div class="control-wrapper">
				${renderControl(context)} ${(x) => x._getFeedbackTemplate(context)}
			</div>
		</template>
	`;
};

const getClasses = ({ shape, connotation, disabled, removable }) => classNames(
  "base",
  ["disabled", disabled],
  ["removable", removable],
  [`shape-${shape}`, Boolean(shape)],
  [`connotation-${connotation}`, Boolean(connotation)]
);
function renderRemoveButton(iconTag) {
  return html`
		<span
			class="remove-button"
			aria-label="${(x) => x.locale.searchableSelect.removeTagButtonLabel(x.label)}"
			role="button"
			tabindex="${(x) => x.disabled ? null : 0}"
			@click="${(x) => x._onClickRemove()}"
		>
			<${iconTag} name="close-line"></${iconTag}>
		</span>
	`;
}
const optionTagTemplate = (context) => {
  const iconTag = context.tagFor(Icon);
  return html`<span class="${getClasses}" aria-disabled="${(x) => x.disabled}">
		<slot name="icon" aria-hidden="true">
			${when(
    (x) => x.hasIconPlaceholder,
    html`<div class="icon-placeholder"></div>`
  )}
		</slot>
		${when(
    (x) => x.label,
    (x) => html`<span class="label">${x.label}</span>`
  )}
		${when((x) => x.removable, renderRemoveButton(iconTag))}
	</span>`;
};

const optionTagDefinition = defineVividComponent(
  "option-tag",
  OptionTag,
  optionTagTemplate,
  [iconDefinition],
  {
    styles: [optionTagStyles],
    shadowOptions: {
      delegatesFocus: true
    }
  }
);
const searchableSelectDefinition = defineVividComponent(
  "searchable-select",
  SearchableSelect,
  SearchableSelectTemplate,
  [
    buttonDefinition,
    popupDefinition,
    iconDefinition,
    optionTagDefinition,
    progressRingDefinition,
    feedbackMessageDefinition
  ],
  {
    styles
  }
);
const registerSearchableSelect = createRegisterFunction(
  searchableSelectDefinition
);

export { SearchableSelect as S, registerSearchableSelect as r };
